import { Box, FieldSet, FormField, Text } from "@wix/design-system";
import React from "react";
import { InputWithSlider } from "./../input-with-slider/input-with-slider";
const NumberInputWithLabel = ({ label, dataHook, suffix, onChange, min, max, value, logBi, zIndex }) => {
  const handleInput = (numberValue) => {
    const valueWithinBounds = isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue;
    logBi?.({ dataHook, value: valueWithinBounds });
    return onChange(valueWithinBounds);
  };
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(FormField, { inputWidth: "100%" }, /* @__PURE__ */ React.createElement(FieldSet, { columns: "auto 72px", alignment: "center", legend: void 0 }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, label), /* @__PURE__ */ React.createElement(
    InputWithSlider,
    {
      value,
      onChange: handleInput,
      zIndex,
      suffix,
      min,
      max,
      dataHook
    }
  ))));
};
export {
  NumberInputWithLabel
};
//# sourceMappingURL=number-input-with-label.js.map
